"use client";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { usePages } from "../context/PageContext";
import api from "../api"; // Use the central API instance
const PageView = () => {
  const { slug } = useParams(); // e.g., 'about', 'contact', 'return-policy'
  const { pages } = usePages();
useEffect(() => {
    document.title = slug;

    // Intercept form submission
     // Intercept form submission
    const formHandler = (e) => {
      if (e.target.tagName === "FORM") {
        e.preventDefault();
        const form = e.target;
        const formData = Object.fromEntries(new FormData(form).entries());

        // Use api.post instead of fetch
        api
          .post("/api/contact/send", formData)
          .then((res) => {
            if (res.data.success) {
              alert("Message sent successfully!");
              form.reset();
            } else {
              alert("Failed to send message.");
            }
          })
          .catch((err) => {
            console.error(err);
            alert("Error sending message.");
          });
      }
    };
    document.addEventListener('submit', formHandler);
    return () => document.removeEventListener('submit', formHandler);
  }, [slug]);
 
  
  // Map URL slugs to footer API keys
  const slugToPageKey = {
    about: "About Us",
    contact: "Contact Us",
    "price-match-policy": "Price Match Policy",
    "return-policy": "Return Policy",
    "shipping-delivery": "Shipping & Delivery",
    "privacy": "Privacy Policy",
    "recall-notices": "Recall Notices",
    "terms": "Terms & Conditions",
    faq: "FAQs",
    sizing: "Sizing",
    "custom-imprinting": "Custom Imprinting & Embroidery",
    "custom-quote": "Custom Quote",
  };
 
  const pageKey = slugToPageKey[slug];
  const page = pages[pageKey];
   console.log(pages[pageKey]);
  const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')   // replace spaces/special chars with -
    .replace(/(^-|-$)/g, ''); 
  const pageId = slugify(page.name);
  if (!page) {
    return <div className="container py-5"><h2>Page Not Found</h2></div>;
  }

  return (
    <div className="container py-5 p-color">
      <h1 className="mb-3" id={pageId}>{page.name}</h1>
      <div dangerouslySetInnerHTML={{ __html: page.description }} />
    </div>
  );
};

export default PageView;
